import { render, staticRenderFns } from "./WebviewMultiploContas.vue?vue&type=template&id=4b64fbb9&scoped=true"
import script from "./WebviewMultiploContas.vue?vue&type=script&lang=js"
export * from "./WebviewMultiploContas.vue?vue&type=script&lang=js"
import style0 from "./WebviewMultiploContas.vue?vue&type=style&index=0&id=4b64fbb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64fbb9",
  null
  
)

export default component.exports